import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  container: {
    margin: '3rem auto',
    justifyContent: 'center',
  },
  button: {
    textTransform: 'initial',
    textDecoration: 'underline',
    fontSize: 22
  }
}));